import { render, staticRenderFns } from "./project-dialog.vue?vue&type=template&id=e89c7a3a&scoped=true"
import script from "./project-dialog.vue?vue&type=script&lang=js"
export * from "./project-dialog.vue?vue&type=script&lang=js"
import style0 from "./project-dialog.vue?vue&type=style&index=0&id=e89c7a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89c7a3a",
  null
  
)

export default component.exports